export const hotelTabTypes = {
  main: "メイン",
  recommended: "おすすめ",
};
